// lib
import PropTypes from 'prop-types'

// components
import { Dropdown } from 'primereact/dropdown'
import { optionRow } from '@aytm/app/stats/page/question-views/components/controls/OptionLabel'
import Popup from '@aytm/lib/rfd-ui/components/basic/popup'
import { pressable } from '@aytm/app/stats/components/lib/pressable'
import {
  HELP_OPTIONS,
  DEFAULT_SELECT_VALUES,
  DROPDOWN_TEXT
} from '@aytm/app/stats/page/question-views/sh/lib/constants'

// styles
import style from '@aytm/app/stats/page/question-views/components/controls/styles/Controls.module.scss'
import { NO_PRINT } from '@aytm/app/stats/page/question-views/components/lib/constants'

const Controls = ({ options, type, viewMode, chartCollapsed, onToggle, onModelChange }) => {
  const dropdownText = DROPDOWN_TEXT?.[type]
  const helpText = HELP_OPTIONS?.[type]?.[viewMode] || ''
  const resolvedViewMode = viewMode || DEFAULT_SELECT_VALUES?.[type]

  const handleChangeViewMode = event => {
    onModelChange({
      viewMode: event.value
    })
  }

  const handleToggle = () => {
    onToggle(!chartCollapsed)
  }

  return (
    <div data-sub-block={type} className={`${style.component} ${NO_PRINT}`}>
      <span className="p-field">{dropdownText}</span>
      <div className="p-fluid p-col-4">
        <Dropdown
          className="p-dropdown-rounded"
          aria-label={dropdownText}
          ariaLabel={dropdownText}
          value={resolvedViewMode}
          options={options}
          optionValue="value"
          optionLabel="text"
          optionDisabled="disabled"
          fixedDropdownDir="bottom"
          itemTemplate={optionRow(`sh-${type}-view-mode`)}
          onChange={handleChangeViewMode}
        />
      </div>
      {helpText ? (
        <Popup
          width="300px"
          trigger="click"
          direction="righttop"
          popupOffset={9}
          hideOtherPopupsOnShow
          content={() => <p dangerouslySetInnerHTML={{ __html: helpText }} />}
        >
          <i className="icon-aytmfd-help-v2" />
        </Popup>
      ) : null}
      <span className={`${style.toggle} p-right`} aria-expanded={!chartCollapsed} {...pressable(handleToggle)}>
        {chartCollapsed ? 'Expand' : 'Collapse'}
      </span>
    </div>
  )
}

Controls.propTypes = {
  type: PropTypes.oneOf(['shelf', 'product-metrics']),
  options: PropTypes.array,
  viewMode: PropTypes.string,
  chartCollapsed: PropTypes.bool,
  onModelChange: PropTypes.func,
  onToggle: PropTypes.func
}

Controls.displayName = 'Controls'

export default Controls
